module.exports = __webpack_public_path__ + "static/media/image-001.0acb8943.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image-001.jpg
// module id = 806
// module chunks = 0